/* eslint-disable */
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import DataTable from "../DataTable/DataTable";
import { getSubscribedUsersList, getStatisticsSuccess } from "../../../actions";
import { history } from "../../../config/stores";
import Header from "../../Header/Header";
import "./FreeUsers.scss";

const FreeUsers = ({ getSubscribedUsersList, getStatisticsSuccess, freeUsers }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [filters, setFilters] = useState({
    name: "",
    email: ""
  });

  // Helper function to create API payload
  const createApiPayload = (page = 1, additionalFilters = {}) => ({
    type: "free",
    name: additionalFilters.hasOwnProperty('fullName') ? additionalFilters.fullName || "" : filters.name || "",
    email: additionalFilters.hasOwnProperty('email') ? additionalFilters.email || "" : filters.email || "",
    registeredFrom: "",
    registeredTo: "",
    propertiesFrom: null,
    propertiesTo: null,
    walletsFrom: null,
    walletsTo: null,
    bankAccountsFrom: null,
    bankAccountsTo: null,
    page,
    limit: 20,
    onSuccess: () => setIsLoading(false),
    onError: () => setIsLoading(false)
  });

  // Handle filter changes from DataTable
  const handleFilterChange = (columnFilters) => {
    const newFilters = {
      name: columnFilters.fullName || "",
      email: columnFilters.email || ""
    };
    
    setFilters(newFilters);
    setCurrentPage(1); // Reset to first page when filtering
    setIsLoading(true);
    
    // Clear previous data and fetch with new filters
    getStatisticsSuccess({ type: "freeUsers", loading: true, docs: [], hasNextPage: false });
    getSubscribedUsersList(createApiPayload(1, columnFilters));
  };

  useEffect(() => {
    // Set loading state and fetch free users
    getStatisticsSuccess({ type: "freeUsers", loading: true });
    setIsLoading(true);
    
    getSubscribedUsersList(createApiPayload(1));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleLoadMore = () => {
    if (freeUsers?.hasNextPage && !isLoading) {
      const nextPage = currentPage + 1;
      setCurrentPage(nextPage);
      setIsLoading(true);
      
      getSubscribedUsersList(createApiPayload(nextPage));
    }
  };

  const handleBackToDashboard = () => {
    history.push('/');
  };

  return (
    <>
      <Header />
      <div className="main-container">
        <div className="inner-header-container">
          <div className="left-part">
            <div 
              className="close-icon" 
              onClick={handleBackToDashboard}
              title="Back to Dashboard"
            />
            <div className="inner-title">FREE USERS</div>
          </div>
        </div>
        <div className="body-container">
          <DataTable
            data={freeUsers || { docs: [] }}
            preset="freeUsers"
            isLoading={freeUsers?.loading || isLoading}
            onLoadMore={handleLoadMore}
            fetchData={(payload) => {
              // Update current page and loading state
              setCurrentPage(payload.page);
              setIsLoading(true);
              
              // Create the API payload with proper filter handling
              const apiPayload = createApiPayload(payload.page, payload.filters || {});
              
              getSubscribedUsersList({
                ...apiPayload,
                onSuccess: () => setIsLoading(false),
                onError: () => setIsLoading(false)
              });
            }}
            onFilterChange={handleFilterChange}
            hasMore={freeUsers?.hasNextPage}
            emptyStateText="No free users found"
          />
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  freeUsers: state.dashboard.freeUsers,
});

const mapDispatchToProps = (dispatch) => ({
  getSubscribedUsersList: (payload) => dispatch(getSubscribedUsersList(payload)),
  getStatisticsSuccess: (payload) => dispatch(getStatisticsSuccess(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FreeUsers);
